import(/* webpackMode: "eager" */ "/builds/client-projects/bazaar/bazaar-web-app/site/src/app/(auth)/login/page.tsx")